// extracted by mini-css-extract-plugin
export default {"root":"PriceFilterPopup_root__eQrkR","btn":"PriceFilterPopup_btn__Mxjps","btnSelected":"PriceFilterPopup_btnSelected__yvzph"};